import React, { useState } from 'react'
import { HashLink } from 'react-router-hash-link'
import Icon from '../../ui/Icon/Icon'
import scrollWithOffset from '../../ui/ScrollToTop/scrollWithOffset'
import './CookieNotification.sass'

function CookieNotification() {
  const [acceptedCookie, setAcceptedCookie] = useState(
    localStorage.getItem('acceptedCookies')
  )

  const onCookiesAccept = () => {
    localStorage.setItem('acceptedCookies', true)
    setAcceptedCookie(true)
  }

  return !acceptedCookie ? (
    <div className="Site-CookieNotification">
      <div className="CookieNotification-Container">
        <div className="CookieNotification-Button">
          <Icon name="times" onClick={onCookiesAccept} />
        </div>
        <div className="CookieNotification-Text">
          Мы используем cookie-файлы для наилучшего представления нашего сайта.
          Цели использования файлов cookie определены в{' '}
          <a href="/docs/policy.pdf">Политике обработки персональных данных</a>.
          Если вы не согласны и дальше получать файлы cookie, пожалуйста,
          закройте данный сайт
        </div>
      </div>
    </div>
  ) : null
}

export default CookieNotification
